/**
 * Home route for the signed-in audience.
 * Platform superusers land on /platform; agency staff on /.
 */
export function homePath(user) {
  return user?.is_superuser ? "/platform" : "/";
}

const AGENCY_ONLY_PREFIXES = [
  "/schedule",
  "/visits",
  "/care-plans",
  "/clients",
  "/caregivers",
  "/settings",
];

/**
 * Pick a safe post-login (or already-authenticated) destination.
 * Honors `from` only when that path is allowed for the user's audience.
 */
export function resolvePostLoginPath(user, from) {
  const home = homePath(user);
  if (!from || from === "/login") {
    return home;
  }

  if (user?.is_superuser) {
    if (from === "/" || AGENCY_ONLY_PREFIXES.some((p) => from === p || from.startsWith(`${p}/`))) {
      return "/platform";
    }
    return from;
  }

  if (from === "/platform" || from.startsWith("/admin")) {
    return "/";
  }
  return from;
}
